import { render, staticRenderFns } from "./NY-Notice-Of-Excess.vue?vue&type=template&id=2dd7c0ca&scoped=true&"
import script from "./NY-Notice-Of-Excess.vue?vue&type=script&lang=js&"
export * from "./NY-Notice-Of-Excess.vue?vue&type=script&lang=js&"
import style0 from "./NY-Notice-Of-Excess.vue?vue&type=style&index=0&id=2dd7c0ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd7c0ca",
  null
  
)

export default component.exports